import { QueryClient } from '@tanstack/react-query'
import { AxiosResponse } from 'axios'

import { Campaign } from '../../../models/Outreach/types'
import { seasonDetailKey } from './leasingSeasonKeys'

/** Invalidate one season detail cache entry (not the whole leasing-season prefix). */
export function invalidateLeasingSeasonDetail(
    queryClient: QueryClient,
    seasonId: number | null | undefined,
) {
    if (seasonId == null) return
    void queryClient.invalidateQueries({ queryKey: seasonDetailKey(seasonId) })
}

/** Resolve leasing_season from campaign list or detail cache after a mutation. */
export function resolveCampaignSeasonId(
    queryClient: QueryClient,
    campaignId: string | number,
): number | undefined {
    const detail = queryClient.getQueryData<AxiosResponse<Campaign>>([
        'campaigns',
        campaignId,
    ])
    if (detail?.data?.leasing_season != null) {
        return detail.data.leasing_season
    }

    const list = queryClient.getQueryData<AxiosResponse<Campaign[]>>([
        'campaigns',
    ])
    const campaign = list?.data?.find(
        (c) => String(c.id) === String(campaignId),
    )
    return campaign?.leasing_season ?? undefined
}

export function invalidateLeasingSeasonForCampaign(
    queryClient: QueryClient,
    campaignId: string | number,
) {
    invalidateLeasingSeasonDetail(
        queryClient,
        resolveCampaignSeasonId(queryClient, campaignId),
    )
}
